// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Standards: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512">
            <g>
                <g>
                    <path
                        fill="#333"
                        d="M288.2,459.6c-16-27.1-24.6-58.1-24.8-89.5l-.3-44.6c-.1-19.4,11.9-36.6,30-42.8,8.9-3,16.7-8.7,22.4-16.2,8.3-10.9,21.7-17.5,35.7-17.6l59.5-.4h0V25c0-13.8-11.2-25-25-25H40C26.2,0,15,11.2,15,25v462c0,13.8,11.2,25,25,25h294.8c-18.8-14.3-34.7-32.1-46.7-52.4ZM216.3,353.5h-115.8c-8.3,0-15-6.7-15-15s6.7-15,15-15h115.8c8.3,0,15,6.7,15,15s-6.7,15-15,15h0ZM231.3,398.5c0,8.3-6.7,15-15,15h-115.8c-8.3,0-15-6.7-15-15s6.7-15,15-15h115.8c8.3,0,15,6.7,15,15h0ZM216.3,303.5h-115.8c-8.3,0-15-6.7-15-15s6.7-15,15-15h115.8c8.3,0,15,6.7,15,15s-6.7,15-15,15h0ZM216.3,243.9h-115.8c-8.3,0-15-6.7-15-15s6.7-15,15-15h115.8c8.3,0,15,6.7,15,15s-6.7,15-15,15h0ZM216.3,183.8h-115.8c-8.3,0-15-6.7-15-15s6.7-15,15-15h115.8c8.3,0,15,6.7,15,15s-6.7,15-15,15h0ZM324.2,123.8H100.5c-8.3,0-15-6.7-15-15s6.7-15,15-15h223.7c8.3,0,15,6.7,15,15s-6.7,15-15,15h0Z"
                    />
                    <path
                        fill="#ecb41f"
                        d="M422.8,498.6c46.1-27.3,74.6-77.2,74.2-130.3l-.3-44.6c0-6.5-4-12.1-9.9-14-14.7-4.8-27.4-13.7-36.9-25.8-2.8-3.5-7.3-5.6-12-5.6h-.1l-86.3.6c-4.8,0-9.3,2.2-12.1,5.8-9.3,12.3-22,21.4-36.5,26.4-5.9,2-9.8,7.7-9.7,14.2l.3,44.6c.4,53,29.6,102.5,76.1,129.2l19.2,11c4.7,2.7,10.4,2.6,15.1-.1l19-11.3ZM349.7,378.2c6.4-5.2,15.9-4.3,21.1,2.2l14.9,18.3,42.5-45.2c5.7-6,15.2-6.3,21.2-.6,6,5.7,6.3,15.2.6,21.2l-54.3,57.7c-5.7,6-15.2,6.3-21.2.7-.5-.5-.9-.9-1.4-1.5l-25.7-31.6c-5.2-6.4-4.3-15.9,2.2-21.1Z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Standards);
